import React, {useState, useEffect} from "react";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Avatar from "@mui/material/Avatar";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { axiosInstance as axios, endpoint } from "../../../api/axios";
import { useSelector } from 'react-redux';
import { useSnackbar } from "notistack";
import PhoneIcon from '@mui/icons-material/Phone';


// Transition for the slide animation
const Transition = React.forwardRef(function Transition(
  props, // No type annotations here
  ref
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const UpdateProfileDialog = ({
  openUpdateProfile,
  data,
  onReload,
  handleCloseUpdateProfile,
}) => {
  const [dataUpdate, setDataUpdate] = useState({ 
    id: "",
    name: "",
    address: "",
    address_by_idcard: "",
    born_date: "",
    mobile:"",
    email: "",
    gender: ""
  });
  const { enqueueSnackbar } = useSnackbar();
  const currentUserId = useSelector(state => state.user.currentUserId);
  const user = useSelector(state => state.user.users[state.user.currentUserId]);
  const [selectedImage, setSelectedImage] = useState(null);

  const getAge = (bornDate) => {
    if (!bornDate) return "-";
    const birthDate = new Date(bornDate);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
  
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
  
    return age;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDataUpdate((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedImage(file);
    }
  };

  const handleDateChange = (date) => {
    if (!date) return;
  
    const year = date.getFullYear();
    const month = (`0${date.getMonth() + 1}`).slice(-2);
    const day = (`0${date.getDate()}`).slice(-2);        
  
    const formattedDate = `${year}-${month}-${day}`;
  
    setDataUpdate((prev) => ({
      ...prev,
      born_date: formattedDate,
    }));
  };
  


  const handleUpdateProfile = async() => {
    const formData = new FormData();

    for (let key in dataUpdate) {
      formData.append(key, dataUpdate[key]);
    }

    if (selectedImage) {
      formData.append("employee_image", selectedImage);
    }

    try {
      await axios.post(endpoint.Profile.UpdateProfile, formData, {
        headers: {
          Authorization: `${user.token_type} ${user.token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      enqueueSnackbar("Profil berhasil diperbarui", { variant: "success" });
      if (onReload) onReload();
      handleCloseUpdateProfile();
    } catch (error) {
      enqueueSnackbar("Gagal Update Profile", { variant: "error" });
      console.log("Gagal Update Profile", error);
    }
  }

  useEffect(() => {
    if (openUpdateProfile && data) {
      setDataUpdate({
        id: data?.id || "",
        name: data.name || "",
        mobile: data.mobile || "",
        email: data.email || "",
        address: data.address || "",
        address_by_idcard: data.address_by_idcard || "",
        born_date: data.born_date || null,
        gender: data.gender || "",
      });
    }
  }, [openUpdateProfile, data]);
  return (
    <Dialog
      fullScreen
      open={openUpdateProfile}
      onClose={handleCloseUpdateProfile}
      TransitionComponent={Transition}
    >
      <AppBar sx={{ position: "relative" }}>
        <Toolbar sx={{ display: "flex", justifyContent: "flex-end" }}>
          <IconButton
            edge="end"
            color="inherit"
            onClick={handleCloseUpdateProfile}
            aria-label="close"
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography
            sx={{ ml: 2, flex: 1, textAlign: "center" }}
            variant="h6"
            component="div"
          >
            Pengaturan Akun
          </Typography>
        </Toolbar>
      </AppBar>
      <Box sx={{ p: 2, borderRadius: 3, bgcolor: "#f5f5f5", mb: 2 }}>
        <Box display="flex" flexDirection="column" alignItems="center" mb={2}>
        <Avatar
            src={
              selectedImage
                ? URL.createObjectURL(selectedImage)
                : data?.employee_image || ""
            }
            alt="Profile"
            sx={{ width: 80, height: 80 }}
          />
          <Button
            variant="outlined"
            component="label"
            sx={{ mt: 1, fontSize: 12 }}
          >
            Ganti Foto
            <input
              type="file"
              accept="image/*"
              hidden
              onChange={handleImageChange}
            />
          </Button>

          {/* Divider bawah avatar */}
          <Divider
            sx={{
              width: "100%",
              mt: 2,
              borderColor: "rgba(0, 0, 0, 0.1)",
            }}
          />
        </Box>

        <Typography
          variant="body2"
          fontWeight="bold"
          color="text.primary"
          gutterBottom
          sx={{ mb: 2 }}
        >
          Data Diri
        </Typography>

        {/* TextField untuk Nama */}
        <TextField
          fullWidth
          size="small"
          variant="outlined"
          name="name"
          onChange={handleChange}
          value={dataUpdate?.name ? dataUpdate?.name : ""}
          type="text"
          placeholder="Masukkan Nama"
          label="Name"
          sx={{
            mb: 2,
            bgcolor: "#fff",
            borderRadius: 2,
            "& .MuiOutlinedInput-root": {
              borderRadius: 2,
            },
          }}
          InputProps={{
            startAdornment: <InputAdornment position="start"></InputAdornment>,
          }}
        />

         {/* TextField untuk Mobile */}
         <TextField
          fullWidth
          size="small"
          variant="outlined"
          type="number"
          name="mobile"
          disabled
          value={dataUpdate?.mobile ? dataUpdate?.mobile : ""}
          placeholder="Masukkan Nomor Handphone"
          label="Nomor Handphone"
          sx={{
            mb: 2,
            bgcolor: "#fff",
            borderRadius: 2,
            "& .MuiOutlinedInput-root": {
              borderRadius: 2,
            },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <PhoneIcon color="action"/>
              </InputAdornment>
            ),
          }}
        />

        {/* TextField untuk Email */}
        <TextField
          fullWidth
          size="small"
          variant="outlined"
          type="email"
          name="email"
          disabled
          value={dataUpdate?.email ? dataUpdate?.email : ""}
          placeholder="email@example.com"
          label="Email"
          sx={{
            mb: 2,
            bgcolor: "#fff",
            borderRadius: 2,
            "& .MuiOutlinedInput-root": {
              borderRadius: 2,
            },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <EmailOutlinedIcon color="action" />
              </InputAdornment>
            ),
          }}
        />

        <FormControl
          fullWidth
          sx={{
            mb: 2,
          }}
        >
          <FormLabel id="gender-label">Jenis Kelamin</FormLabel>
          <RadioGroup
            row
            aria-labelledby="gender-label"
            name="gender"
            value={dataUpdate?.gender ? dataUpdate?.gender : ""}
            onChange={handleChange}
          >
            <FormControlLabel
              value="Laki-laki"
              control={<Radio />}
              label="Laki-laki"
            />
            <FormControlLabel
              value="Perempuan"
              control={<Radio />}
              label="Perempuan"
            />
          </RadioGroup>
        </FormControl>

        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Grid container spacing={2} sx={{ mb: 2 }}>
            {/* Tanggal Lahir */}
            <Grid item xs={12} sm={6}>
              <DatePicker
                label="Tanggal Lahir"
                name="born_date"
                value={dataUpdate?.born_date ? new Date(dataUpdate.born_date) : null}
                onChange={handleDateChange}
                slotProps={{
                  textField: {
                    size: "small",
                    fullWidth: true,
                    variant: "outlined",
                    sx: {
                      bgcolor: "#fff",
                      borderRadius: 2,
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 2,
                      },
                    },
                    InputProps: {
                      startAdornment: (
                        <InputAdornment position="start"></InputAdornment>
                      ),
                    },
                  },
                }}
              />
            </Grid>

            {/* Usia */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                type="number"
                label="Usia"
                disabled
                value={getAge(dataUpdate?.born_date) ? getAge(dataUpdate?.born_date) : ""}
                placeholder="Masukkan usia"
                sx={{
                  bgcolor: "#fff",
                  borderRadius: 2,
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 2,
                  },
                }}
              />
            </Grid>
          </Grid>
        </LocalizationProvider>

        <Grid container spacing={2} sx={{ mb: 2 }}>
          {/* Alamat Saat Ini */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              multiline
              rows={3}
              size="small"
              name="address"
              onChange={handleChange}
              value={dataUpdate?.address ? dataUpdate?.address : ""}
              variant="outlined"
              label="Alamat Saat Ini"
              placeholder="Masukkan alamat tinggal saat ini"
              sx={{
                mb: 2,
                bgcolor: "#fff",
                borderRadius: 2,
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start"></InputAdornment>
                ),
              }}
            />
          </Grid>

          {/* Alamat Sesuai KTP */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              multiline
              rows={3}
              size="small"
              variant="outlined"
              name="address_by_idcard"
              onChange={handleChange}
              value={dataUpdate?.address_by_idcard ? dataUpdate?.address_by_idcard : ""}
              label="Alamat Sesuai KTP"
              placeholder="Masukkan alamat sesuai KTP"
              sx={{
                mb: 2,
                bgcolor: "#fff",
                borderRadius: 2,
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start"></InputAdornment>
                ),
              }}
            />
          </Grid>
        </Grid>

        {/* <Typography
          variant="body2"
          fontWeight="bold"
          color="text.primary"
          gutterBottom
          sx={{ mb: 2 }}
        >
          Saya Ingin Tutup Akun
        </Typography> */}

        {/* Tombol Tutup Akun */}
        {/* <Button
          variant="outlined"
          fullWidth
          color="primary"
          sx={{
            textTransform: "none",
            borderRadius: 5,
            mb: 2,
            borderWidth: 2,
            ":hover": {
              borderColor: "primary.dark",
              bgcolor: "primary.light",
              color: "#fff",
            },
          }}
        >
          Tutup Akun
        </Button> */}

        {/* Tombol Simpan */}
        <Button
          variant="contained"
          onClick={handleUpdateProfile}
          fullWidth
          sx={{
            textTransform: "none",
            bgcolor: "#424242",
            borderRadius: 5,
            ":hover": {
              bgcolor: "#08306b",
            },
          }}
        >
          Simpan
        </Button>
      </Box>
    </Dialog>
  );
};

export default UpdateProfileDialog;
